<div class="layout-wrapper">
  <pv2-notify-component></pv2-notify-component>
  <router-outlet></router-outlet>
</div>
